export default __webpack_public_path__ + "static/media/goal-retirement.a6318a7d.svg";